import { RSAA } from 'redux-api-middleware'

import { types, initialState } from './index'
import { contentfulEndpoint, getContentfulProxyHeaders } from './utils'

/**
 * Help center fetch contentful data that requires a graphql query
 *
 * @param {String} query The graphql query, should be passed in to the endpoint
 *   from the the component thats calling this action
 */
export const fetchHelpSearchData = query => {
  return {
    [RSAA]: {
      endpoint: contentfulEndpoint,
      method: 'POST',
      headers: getContentfulProxyHeaders(),
      body: JSON.stringify({ query }),
      types: [
        types.FETCH_HELP_SEARCH_DATA_REQUEST,
        types.FETCH_HELP_SEARCH_DATA_SUCCESS,
        types.FETCH_HELP_SEARCH_DATA_ERROR,
      ],
      cache: true,
    },
  }
}

export const clearHelpSearchData = () => ({
  type: types.CLEAR_HELP_SEARCH_DATA,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    // -- Help search Contentful store
    case types.FETCH_HELP_SEARCH_DATA_REQUEST: {
      return {
        ...state,
        articlesBySearch: {
          ...state.articlesBySearch,
          busy: true,
          error: null,
        },
      }
    }

    case types.FETCH_HELP_SEARCH_DATA_SUCCESS: {
      const { data } = payload

      // We reached the last page if the total is smaller than a single page
      // or the total is smaller than the current skip amount
      const isLastPageReached =
        data?.articlesBySearch.total <= 20 ||
        data?.articlesBySearch.total <= data?.articlesBySearch.skip
          ? true
          : false

      // Append the new articles to the existing ones
      const mergedEntities = state.articlesBySearch.entities.concat(
        data.articlesBySearch.articles,
      )

      return {
        ...state,
        articlesBySearch: {
          ...state.articlesBySearch,
          busy: false,
          skip: data.articlesBySearch.skip,
          total: data.articlesBySearch.total,
          isLastPageReached: isLastPageReached,
          entities: mergedEntities,
        },
      }
    }

    case types.FETCH_HELP_SEARCH_DATA_ERROR: {
      return {
        ...state,
        articlesBySearch: {
          ...state.articlesBySearch,
          busy: false,
          error: payload,
        },
      }
    }

    case types.CLEAR_HELP_SEARCH_DATA: {
      return {
        ...state,
        articlesBySearch: {
          ...state.articlesBySearch,
          entities: initialState.articlesBySearch.entities,
        },
      }
    }

    default:
      return state
  }
}
